var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#116EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.74518 10.448C5.34624 10.0441 4.70135 10.0406 4.29984 10.4471C3.90098 10.8509 3.89746 11.5134 4.30485 11.9144L8.02016 15.6934C8.2126 15.8883 8.47208 16 8.74319 16C9.07214 15.9892 9.34937 15.8548 9.53684 15.6176L16.7679 6.6939C17.1275 6.25011 17.0615 5.59878 16.6236 5.23503C16.1852 4.87087 15.5419 4.93776 15.1826 5.38108L8.66718 13.4217L5.74518 10.448Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Checked.f32c00d154d2f35526dc91dabf6dbe17.svg";